import { TAB_IDS } from "./wasteFlowConstants";

export const WASTE_WIZARD_STEP_IDS = [
  TAB_IDS.general,
  TAB_IDS.costs,
  TAB_IDS.proUnauthorized,
  TAB_IDS.hwUnauthorized,
];

export function getWizardStepIds({ includeHw = true } = {}) {
  const ids = [TAB_IDS.general, TAB_IDS.costs, TAB_IDS.proUnauthorized];
  if (includeHw) ids.push(TAB_IDS.hwUnauthorized);
  return ids;
}

export function getWizardStepIndex(stepId, stepIds = WASTE_WIZARD_STEP_IDS) {
  const index = stepIds.indexOf(stepId);
  return index >= 0 ? index : 0;
}
